export const environment = {
  production: false,
  type: "dev",
  twitterURL: "https://twitter.com/somosavla",
  facebookURL: "https://es-la.facebook.com/somosavla",
  linkedinURL: "https://cl.linkedin.com/company/somosavla",
  instagramURL: "https://www.instagram.com/somosavla/",
  youtubeURL: "https://www.youtube.com/@AVLAcorp",
  ventaEnVerdeURL: "https://ventaverde.avla.com/cl/ventaenverde/login",
  seguroDeGarantiaURL: "https://portalclientes.avla.com/#/login",
  seguroDeCreditoURL: "https://portalclientes.avla.com/#/login",
  agilidadAvlaURL: "https://www.avla.com/cl/productos/polizas-de-garantia",
  misionAvlaURL: "https://www.avla.com/cl/quienes-somos",
  impactoEsgURL: "https://www.avla.com/cl/impacto",
  avlaFormURL: "https://form.jotform.com/231426255074856",
  API_PREFIX: "/api-venta-en-verde",
  API_HOST: `r9ncs0w9h9.execute-api.us-east-1.amazonaws.com/dev/api-ventaverde`,
  API_PORT: ``,
  API_PROTOCOL: `https://`,
  recaptcha: {
    siteKey_v2: "6LdlsmwcAAAAAH8OVyCRvx73qn7N2mmizo_g190b",
    siteKey_v3: "6LduH1UaAAAAACO9gCX0sVc_U9rXbfD8r83xr9aS",
  },
  googleTagManagerId: ""
};

